import { el } from 'redom';

import CSSNumberValueControl from 'generics/components/css-number-value-control/native';

import './index.scss';

class ShadowForm {

  constructor(configuration) {

    this.value = configuration.value;
    this.onChange = configuration.onChange;

    this.blurInput = new CSSNumberValueControl({
      value: this.value.blur || '',
      placeholder: 'Blur',
      onChange: (value) => {
        let actualValue = value;
        if (typeof value === 'string') {
          actualValue = +value.replace('px', '');
        }
        this.handleBlurChange(actualValue);
      }
    });
    this.offsetXInput = new CSSNumberValueControl({
      value: this.value.offsetX || '',
      placeholder: 'X',
      onChange: (value) => {
        let actualValue = value;
        if (typeof value === 'string') {
          actualValue = +value.replace('px', '');
        }
        this.handleOffsetXChange(actualValue);
      }
    });
    this.offsetYInput = new CSSNumberValueControl({
      value: this.value.offsetY || '',
      placeholder: 'Y',
      onChange: (value) => {
        let actualValue = value;
        if (typeof value === 'string') {
          actualValue = +value.replace('px', '');
        }
        this.handleOffsetYChange(actualValue);
      }
    });

    this.el = el('#shadow-form', [this.blurInput, this.offsetXInput, this.offsetYInput]);

  }

  handleBlurChange(blur) {

    this.value.blur = blur;

    this.onChange(this.value);

  }

  handleOffsetXChange(offsetX) {

    this.value.offsetX = offsetX;

    this.onChange(this.value);

  }

  handleOffsetYChange(offsetY) {

    this.value.offsetY = offsetY;

    this.onChange(this.value);

  }

}

export default ShadowForm;